import React from 'react';
import Search from '../../../components/Search/index';

const SearchPage = () => <Search />;

export default SearchPage;
